import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'lib-side-menu-list-item-link',
  imports: [MatListModule, MatIconModule, RouterModule],
  template: `
    <button
      mat-list-item
      class="search-options-item"
      [routerLink]="[href()]"
      queryParamsHandling="preserve"
    >
      <span matListItemTitle class="mat-label-medium option-label">{{
        title()
      }}</span>
      @if (subtitle()) {
        <span matListItemLine class="mat-label-medium option-desc">{{
          subtitle()
        }}</span>
      }
      <mat-icon matListItemIcon class="option-icon">chevron_right</mat-icon>
    </button>
  `,
  styles: `
    @use 'side-menu-list-item' as *;

    @include side-menu-list-item;
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuListItemLinkComponent {
  title = input.required<string>();
  subtitle = input<string>();
  href = input.required<string>();
}
